const BREAKPOINT_DOWNLOAD_TABLE = 1600;

$(document).ready(function () {
    $('.js-download-table').each(function (i, table) {
        setTableObservers($(table));
        setDownloadTableHeadlinesWidths($(table));
        $(window).resize(function () {
            setDownloadTableHeadlinesWidths($(table));
        })
    })
})

function setTableObservers($table) {

    let $firstHeadline = $table.find('.js-original-headlines .js-download-table-headline[data-index="0"]');
    if ($firstHeadline.length <= 0) {
        return;
    }

    let headerHeight = getComputedStyle(document.body).getPropertyValue('--header-height');
    if (headerHeight.includes('vw')) {
        headerHeight = window.innerWidth / 100 * parseFloat(headerHeight.substring(0, headerHeight.indexOf('v')));
    }

    let optionsTableHeadlinesObserver = {
        root: null,
        threshold: 1
    }

    if (!isNaN(headerHeight)) {
        optionsTableHeadlinesObserver.rootMargin = '-' + headerHeight + 'px';
    }

    // set sticky
    let tableHeadlinesObserver = new IntersectionObserver(
        function (entries) {
            entries.forEach(entry => {
                let $table = $(entry.target).closest('.js-download-table');
                if (entry.isIntersecting) {
                    // element is in viewport
                    setDownloadTableHeadlinesWidths($table);
                    updateDownloadTableHeadlines($table, false);
                } else {
                    // element in not in viewport
                    updateDownloadTableHeadlines($table, true);
                }
            });
        }, optionsTableHeadlinesObserver
    )
    tableHeadlinesObserver.observe($firstHeadline[0]);

    let optionsUpScroll = {
        root: null,
        threshold: 0.01
    }
    if (!isNaN(headerHeight)) {
        optionsUpScroll.rootMargin = '-' + headerHeight * 3 + 'px';
    }
    let tableObserverUpScroll = new IntersectionObserver(
        function (entries) {
            entries.forEach(entry => {
                let $table = $(entry.target).closest('.js-download-table');
                if (currentScrollDirection === SCROLL_DIRECTIONS.down) {
                    updateDownloadTableHeadlines($table, false);
                } else if (currentScrollDirection === SCROLL_DIRECTIONS.up) {
                    setDownloadTableHeadlinesWidths($table);
                    updateDownloadTableHeadlines($table, true);
                }

            });
        }, optionsUpScroll
    )
    tableObserverUpScroll.observe($table.find('.js-download-table-wrapper').first()[0]);

}

function updateDownloadTableHeadlines($table, shouldBeSticky) {
    let $container = $table.find('.js-duplicated-headlines');
    if (shouldBeSticky) {
        $container.addClass('is-sticky');
    } else {
        $container.removeClass('is-sticky');
    }
}

function setDownloadTableHeadlinesWidths($table) {
    if (window.innerWidth > BREAKPOINT_DOWNLOAD_TABLE) {
        $table.find('.js-original-headlines .js-download-table-headline').each(function (i, headline) {
            let $headline = $(headline),
                width = $headline.outerWidth(),
                index = $headline.attr('data-index');

            let $duplicatedHeadline = $table.find('.js-duplicated-headlines .js-download-table-headline[data-index="' + index + '"]');
            if ($duplicatedHeadline.length >= 1) {
                $duplicatedHeadline.css('flex-basis', width + 'px');
            }
        })
    }
}
